module.exports = {
  ENV: 'prod', //prod
  API_URL: 'https://gardenparts.pl/api/v1',
  //API_URL: 'http://test.gardenparts.pl/api/v1'
  //API_URL: 'http://gardenpartslen.pl/api/v1'
}